import { useSearchParams } from "react-router-dom";
import EmailTemplatesService from "../../../services/EmailTemplatesService";
import { EmailTemplate } from "../../../models";
import { useEffect, useState } from "react";
import { CreateTemplate } from "./ui/buttons";
import TemplatesTable from "./ui/templates-table";
import EmailTemplatesSkeleton from "./skeleton/email-templates-skeleton";

export default function EmailTemplatesPage() {
    const [searchParams] = useSearchParams();
       const api = new EmailTemplatesService();
       const [templates,setTemplates] = useState<EmailTemplate[]>([]);
       const [loading, setLoading] = useState(true);

       useEffect(() => {     
         fetchTemplates();
       }, [searchParams.get("reload")]);
       
       const fetchTemplates = async () => {
         const data = await api.getEmailTemplates();
         setTemplates(data);
         setLoading(false);     
       };
         
     return (
       <div className="w-full">
         <div className="flex w-full items-center justify-between">
           <h1 className={` text-2xl`}>Email Templates</h1>
         </div>
         <CreateTemplate />
         {loading ? <EmailTemplatesSkeleton /> : <TemplatesTable templates={templates} />}
       </div>
     );
   
}